import React from 'react';
import {UiText} from '~/components/elements';
import {spacing} from '~/utils/theme/spacing';

const SpecialText = ({text}: {text: string}) => {
  const pattern = /b!(\w+)/;
  const match = text.match(pattern);

  if (match !== null) {
    const beforeMatch = text.substring(0, match.index ?? undefined);
    const afterMatch = text.substring((match.index ?? 0) + match[0].length);
    const boldText = <strong>{match[1]}</strong>;

    return (
      <span style={{marginBottom: '20px'}}>
        <span style={{color: '#647576', fontSize: '14px'}}>{beforeMatch}</span>
        <span>{boldText}</span>
        <span style={{color: '#647576', fontSize: '14px'}}>{afterMatch}</span>
      </span>
    );
  }
  return (
    <UiText color="blackSecondary" fontSize="sm" mb={spacing.small}>
      {text}
    </UiText>
  );
};

export default SpecialText;
